import AppRouter from './Routes/Router';

function App() {
    return (
        <div>
            <AppRouter />
        </div>
    );
}

export default App;
